import { useEffect, useState } from 'react';

import { fetch_payout_deleted_summary } from '../api';
import { deleted_summary_view } from './deleted_alert';

/*
 * PROD-7828 D10 — how many deleted accounts have money due, for the page banner and the Bank payouts badge.
 * Read on mount and whenever rev moves (a payout write); never read when the CMS user lacks a payouts role
 * (enabled=false). A 403 or 404 (older goserver) reads as none; any other failure keeps the last figure.
 */
export const useDeletedSummary = (rev = 0, enabled = true) => {
  const [view, setView] = useState({ count: 0, complete: true });
  useEffect(() => {
    if (!enabled) {
      setView({ count: 0, complete: true });
      return undefined;
    }
    let cancelled = false;
    fetch_payout_deleted_summary()
      .then((data) => {
        if (!cancelled) setView(deleted_summary_view(data));
      })
      .catch((e) => {
        const status = e && e.response && e.response.status;
        if (!cancelled && (status === 403 || status === 404)) setView({ count: 0, complete: true });
      });
    return () => {
      cancelled = true;
    };
  }, [rev, enabled]);
  return view;
};

export default useDeletedSummary;
